import React from 'react'
import RichText from '/react4xp/components/RichText'
import Office from '/react4xp/components/Office'
import { OfficeType } from '/react4xp/components/Office/type'

interface Props {
   title?: string,
   intro?: string,
   note?: string,
   offices?: OfficeType[],
}

export default function ListOffices(props: Props) {
   const { title, intro, note, offices } = props
   
   return (
      <div className="list-offices">
         {(title || intro) &&
            <div className="grid-container">
               <div className="grid-row">
                  <div className="c-md-8">
                     <div className="list-offices__header">
                        {title && <h1>{title}</h1>}
                        {intro && <p>{intro}</p>}
                     </div>
                  </div>
               </div>
            </div>
         }
         {note &&
            <div className="grid-container">
               <div className="grid-row">
                  <div className="c-12">
                     <div className="list-offices__note">
                        <RichText content={note} />
                     </div>
                  </div>
               </div>
            </div>
         }
         {offices &&
            <div className="grid-container">
               <div className="grid-row list-offices__wrapper">
                  {offices.map((office, index) => {
                     return <div key={index} className="c-md-4 c-sm-6 c-12">
                        <Office {...office} />
                     </div>
                  })}
               </div>
            </div>
         }
      </div>
   )
}
